import { Box, Typography } from '@mui/material'
import React from 'react'

interface AdminMenuTitleProps {
    title: string | React.ReactNode
    upperCase?: boolean
    paddingBottom?: number
}

function AdminMenuTitle({
    title,
    upperCase = true,
    paddingBottom = 1,
}: AdminMenuTitleProps) {
    return (
        <Typography
            variant="h5"
            sx={{ pb: paddingBottom }}
            className={upperCase ? 'textUpper' : undefined}
        >
            <Box display="flex" alignItems="center">
                {title}
            </Box>
        </Typography>
    )
}

export default AdminMenuTitle
